export default __webpack_public_path__ + "static/media/bloodforaid1.abaa578d.png";